export default "__VITE_ASSET__BkhZk7Vu__"